//возвращает Boolean
export default (variable)=>{
    let empty;
    switch(typeof(variable)){
        case "object":
            empty = (JSON.stringify(variable) === "{}" || 
                    JSON.stringify(variable) === "[]" ||
                    variable === null);
            break;
        case "boolean":
            empty = !variable;
            break;
        case "number" :
            empty =  (variable === 0 || isNaN(variable));
            break;
        case "string":
            empty = (variable.trim() === ""); 
            break;
        case "undefined":
            empty =  true;
    };
    return empty;
}